import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './Header';
import Ratestyles from './RateSubmissions.module.css'; // or create RateSubmissions.module.css

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const RateSubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const [filteredSubmissions, setFilteredSubmissions] = useState([]);
  const [submissionMap, setSubmissionMap] = useState({});
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [isJinshiHolder, setIsJinshiHolder] = useState(false);


  useEffect(() => {
    fetchSubmissions();
    fetchJinshiStatus();

  }, []);

  const fetchSubmissions = async () => {
    try {
      const response = await axios.get(`${API_URL}/submissions/final/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const submissions = response.data;
      setSubmissions(submissions);
      setFilteredSubmissions(submissions);

      const map = {};
      submissions.forEach((submission) => {
        const date = new Date(submission.submitted_at);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        map[year] = map[year] || {};
        map[year][month] = map[year][month] || {};
        map[year][month][day] = map[year][month][day] || [];
        map[year][month][day].push(submission);
      });
      setSubmissionMap(map);
    } catch (error) {
      console.error('Error fetching submissions:', error);
    }
  };
  
	const fetchJinshiStatus = async () => {
  	const token = localStorage.getItem('token');
  	if (!token) return;

  	try {
    	const response = await axios.get(`${API_URL}/user/current-level`, {
      		headers: {
        	Authorization: `Bearer ${token}`,
        	"Content-Type": "application/json",
      		},
    		});

    	if (response.data?.achievements?.jinshi) {
      		setIsJinshiHolder(true);
    		} else {
      		setIsJinshiHolder(false);
    	}
  	} catch (error) {
    		console.error("Error fetching Jinshi status:", error);
    		setIsJinshiHolder(false); // fail-safe
  		}
		};


  const filterSubmissions = (year, month, day) => {
    if (!year && !month && !day) {
      setFilteredSubmissions(submissions);
      return;
    }
    let filtered = submissions.filter((submission) => {
      const date = new Date(submission.submitted_at);
      const subYear = date.getFullYear().toString();
      const subMonth = (date.getMonth() + 1).toString().padStart(2, '0');
      const subDay = date.getDate().toString().padStart(2, '0');

      return (!year || subYear === year) &&
             (!month || subMonth === month) &&
             (!day || subDay === day);
    });
    setFilteredSubmissions(filtered);
  };

  const handleRate = async (submissionId, score) => {
    try {
      await axios.post(
        `${API_URL}/submissions/final/rate`,
        {
          submission_id: submissionId,
          score: Number(score),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      // updating UI immediately (so no refresh needed)
      setSubmissions((prev) =>
        prev.map((s) =>
          s._id === submissionId ? { ...s, my_rating: Number(score) } : s
        )
      );

      setFilteredSubmissions((prev) =>
        prev.map((s) =>
          s._id === submissionId ? { ...s, my_rating: Number(score) } : s
        )
      );

      alert("Rating submitted successfully!");
    } catch (error) {
      console.error("Error submitting rating:", error);
      alert("Failed to submit rating.");
    }
  };

  return (
    <>
  <Header />
  <div className={Ratestyles.pageWrapper}> {/* ✅ Fixed: wrap everything inside this */}
    <div className={Ratestyles.contentContainer}>
      <h3 className={Ratestyles.sectionTitle}>
  	{isJinshiHolder ? 'Rate Final Submissions' : 'Jinshi Poetry Gallery'}
      </h3>


      {/* Filters */}
      <div style={{ marginBottom: '20px' }}>
        <label>Year: </label>
        <select
          value={selectedYear}
          onChange={(e) => {
            setSelectedYear(e.target.value);
            filterSubmissions(e.target.value, selectedMonth, selectedDay);
          }}
        >
          <option value="">All</option>
          {Object.keys(submissionMap).sort().reverse().map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>

        <label style={{ marginLeft: '15px' }}>Month: </label>
        <select
          value={selectedMonth}
          onChange={(e) => {
            setSelectedMonth(e.target.value);
            filterSubmissions(selectedYear, e.target.value, selectedDay);
          }}
        >
          <option value="">All</option>
          {selectedYear && Object.keys(submissionMap[selectedYear] || {}).sort().map((month) => (
            <option key={month} value={month}>{month}</option>
          ))}
        </select>

        <label style={{ marginLeft: '15px' }}>Date: </label>
        <select
          value={selectedDay}
          onChange={(e) => {
            setSelectedDay(e.target.value);
            filterSubmissions(selectedYear, selectedMonth, e.target.value);
          }}
        >
          <option value="">All</option>
          {selectedMonth && selectedYear && Object.keys(submissionMap[selectedYear]?.[selectedMonth] || {}).sort().map((day) => (
            <option key={day} value={day}>{day}</option>
          ))}
        </select>
        <span style={{ marginLeft: '10px', fontSize: '0.9em', color: '#555' }}>
          (Only dates with submissions are shown)
        </span>
      </div>

      {/* Submissions */}
      {filteredSubmissions.length > 0 ? (
        <div className={Ratestyles.cardGrid}>
            {filteredSubmissions.map((submission) => (
            <div key={submission._id} className={Ratestyles.submissionCard}>
                <h4 className={Ratestyles.submissionTitle}>{submission.title || 'Final Submission'}</h4>
                <p><strong>Poem Type:</strong> {submission.poem_type || 'Unknown'}</p>
                <p><strong>Submitted At:</strong> {new Date(submission.submitted_at).toLocaleString()}</p>
                <p><strong>Region:</strong> {submission.region || "N/A"}</p>
		<p><strong>Submitted By:</strong> {submission.user_name || 'Unknown'}</p>

                <div className={Ratestyles.submissionContent}>
                {submission.submitted_content.split("\n").map((line, index) => (
                    <div key={index} className={Ratestyles.poemLineWrapper}>
                    <span className={Ratestyles.poemLine}>{line}</span>
                    </div>
                ))}
                </div>

                <div style={{ marginTop: '10px' }}>
  {isJinshiHolder ? (
    <>
      <label>Rate: </label>
      {(() => {
        const submissionDate = new Date(submission.submitted_at);
        const cutoffDate = new Date('2025-03-15T00:00:00Z');
        const isBeforeCutoff = submissionDate < cutoffDate;

        return (
          <>
            <select
              onChange={(e) => handleRate(submission._id, e.target.value)}
              value={submission.my_rating != null ? String(submission.my_rating) : ""}
              disabled={isBeforeCutoff}
            >
              <option value="" disabled>Choose Rating</option>
              <option value="1">1 (Poor)</option>
              <option value="2">2</option>
              <option value="3">3 (Average)</option>
              <option value="4">4</option>
              <option value="5">5 (Excellent)</option>
            </select>
            {isBeforeCutoff && (
              <p style={{ color: 'gray', fontSize: '0.85em' }}>
                Rating disabled for submissions before March 15, 2025.
              </p>
            )}
          </>
        );
      })()}
    </>
  ) : (
    <p style={{ color: 'gray', fontSize: '0.9em' }}>
      Only Jinshi badge holders can rate poems.
    </p>
  )}
</div>

            </div>
            ))}
        </div>
        ) : (
        <p>No submissions found.</p>
        )}
    </div> {/* ✅ closes contentContainer */}
  </div> {/* ✅ closes pageWrapper */}
</>
)}

export default RateSubmissions;
